module.exports = __webpack_public_path__ + "static/media/secret-passion.8bf8d3ac.png";